function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_63135",
  d: "M11.108,17.346a.77.77,0,0,0,.571-.237l2.312-2.32,2.329,2.32a.8.8,0,0,0,1.362-.562.745.745,0,0,0-.237-.554l-2.32-2.329,2.329-2.338a.759.759,0,0,0,.237-.554A.788.788,0,0,0,16.9,9.98a.754.754,0,0,0-.562.246l-2.347,2.329-2.329-2.32A.731.731,0,0,0,11.108,10a.782.782,0,0,0-.8.782.754.754,0,0,0,.246.554l2.32,2.329L10.555,16a.721.721,0,0,0-.246.545A.792.792,0,0,0,11.108,17.346Z",
  transform: "translate(-10.309 -9.98)"
});

function SvgXSign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 7.383 7.365",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXSign);
export default __webpack_public_path__ + "static/media/x-sign.f4df9305.svg";
export { ForwardRef as ReactComponent };